var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-calendar',{attrs:{"type":_vm.calendarType,"min-date":new Date(1990, 0, 1),"max-date":new Date(),"max-range":90},on:{"confirm":_vm.onConfirmDate},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }